export const downloadBase64File = (base64Content, filename, mimeType) => {
  const byteCharacters = atob(base64Content);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const blob = new Blob([new Uint8Array(byteNumbers)], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const REQUIRED_DOCS = [
  { key: 'wage_slip', label: 'Payslips', description: 'Monthly payslips for every month worked', namePatterns: ['payslip', 'wage', 'pay slip'] },
  { key: 'p60', label: 'P60', description: 'End of year certificate from employer', namePatterns: ['p60'] },
  { key: 'contract', label: 'Employment Contracts', description: 'All contracts for the tax year', altKeys: ['employment_contract'], namePatterns: ['contract'] },
  { key: 'discharge_book', label: 'Discharge Book / CDC', description: 'Sea service record', altKeys: ['cdc', 'flight_stub'], namePatterns: ['discharge', 'seaman', 'cdc', 'sea service'] },
  { key: 'p45', label: 'P45', description: 'Leaving certificate (if employment ended)', namePatterns: ['p45'] },
  { key: 'bank_statement', label: 'Bank Statements', description: 'Showing salary payments received', namePatterns: ['bank', 'statement'] },
  { key: 'pension_statement', label: 'Pension Statement', description: 'Annual pension contribution statement', namePatterns: ['pension'] },
  { key: 'travel_receipt', label: 'Travel Receipts', description: 'Receipts for travel to/from port', namePatterns: ['travel', 'receipt', 'flight'] },
];
